import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { Observable } from 'rxjs';

import { Environment } from 'src/environments/environment.model';

import { RepeatOrderResponse } from '../models/repeat-order.response';

@Injectable({ providedIn: 'root' })
export class OrderHistoryService {
  protected baseUrl = `${this.env.API_BASE_URL}/service/order-history/secure/order-history`;

  constructor(
    protected http: HttpClient,
    @Inject(EnvironmentInjector) private env: Environment,
  ) {}

  public get(location: number, salesOrganization: string): Observable<RepeatOrderResponse> {
    return this.http.get<RepeatOrderResponse>(`${this.baseUrl}`, {
      params: { location, salesOrganization },
    });
  }
}
